import { useLayoutEffect, useState } from 'react'

import { useLocalizations } from '@vp/ubik-localizations-provider'

import { useAppState } from '../../../root/contexts/AppContext'
import { useRecommendedCategory } from './useRecommendedCategory'

/** Hook to return the out of stock message and
 * recommended category breadcrumb.
 */
export const useOutOfStockMessage = (expectedDate: Date | undefined) => {
  const { t } = useLocalizations()
  const { culture } = useAppState()
  const [isReady, setIsReady] = useState<boolean>(false)
  const [stockMessage, setStockMessage] = useState<string>()
  const { recommendedCategory, recommendedCategoryIsReady } = useRecommendedCategory()

  useLayoutEffect(() => {
    if (recommendedCategoryIsReady) {
      if (expectedDate) {
        const formattedDate = expectedDate.toLocaleString(culture, {
          month: 'long',
          day: 'numeric',
        })
        const localizationKey = recommendedCategory ? 'item-out-of-stock-date-and-recommendations' : 'item-out-of-stock-no-recommendations'

        const rawLocalizedText = t(`alert-messages.${localizationKey}`)
        const formattedText = rawLocalizedText.replace('{0}', formattedDate)
        setStockMessage(formattedText)
      } else {
        const localizationKey = recommendedCategory ? 'item-out-of-stock-no-date' : 'item-out-of-stock'
        setStockMessage(t(`alert-messages.${localizationKey}`))
      }
      setIsReady(true)
    }
  }, [recommendedCategoryIsReady, recommendedCategory])

  return { stockMessage, recommendedCategory, isReady }
}
